// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { brandsAndSolutionsStyles } from "@guestsupply/App/Components/Header/BrandsAndSolutions";
import CartFilled from "@guestsupply/XDL/Icons/CartFilled";
import { ellipsis, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

brandsAndSolutionsStyles.marketingWrapper = {
    css: css`
        display: flex;
        background-color: white;
        height: 100%;
        max-height: ${({ headerHeight }: any) => `calc((100vh - ${headerHeight || "140px"} - 2px) * 0.8)`};
        width: auto;
        max-width: 1016px;
        transition: all 200ms ease-in-out;
        border: 1px solid ${getColor("common.border")};
        border-top-width: 0;
        border-radius: 0 0 4px 0;
        ${xScreen("lte", "md")} {
            display: block;
            width: 100%;
            padding: 0 16px;
            height: initial;
            max-height: initial;
            height: 100%;
        }
    `,
};
